module.exports = __webpack_public_path__ + "static/media/moons_kit_que_incluye.4a472391.webp";